import React, { useState, useContext, useRef, useEffect } from "react";
import moment from "moment";
import RuumrModal from "../Modal";
import BiddingForm from "./BiddingForm";
import GlobalContext from "../../../context/GlobalContext";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { setDecimalPoint } from "../../../utils";
import Timer from "../Timer/timer";
import PrimaryButton from "../../atoms/PrimaryButton";

const useStyles = makeStyles((theme) => ({
  customFontSize: {
    fontSize: "13px",
  },
}));

const PropertyBids = ({
  data,
  timer,
  nextBidAmount,
  setNextBidAmount,
  rtbCompleted,
  seyProductDetails,
  bidContainer,
  width,
  isMobile,
  myClientsList,
  myAgent,
  from,
  setSubmittedPracticeOffer,
  submittedPracticeOffer,
  setModelopen,
  modalopen,
  submittingBid,
  highestBidder,
  hasRegistered,
}) => {
  const { userLoggedIn, userDetails } = useContext(GlobalContext);
  const [isAuctionTimerCompleted, setIsAuctionTimerCompleted] = useState(false);

  const mobileWidth = useMediaQuery("(max-width:766px)");

  const toggleModal = () => {
    setModelopen(!modalopen);
  };

  const handleAuctionTimerCompleted = (isCompleted) => {
    setIsAuctionTimerCompleted(!!isCompleted);
  };

  useEffect(() => {
    if (timer?.isCompleted === false) {
      setIsAuctionTimerCompleted(false);
    }
  }, [timer?.isCompleted, data?.date_closed, data?.date_added]);

  return (
    <div className="bids-box-wrapper mb-5" ref={bidContainer}>
      {from === "practice" ? (
        ""
      ) : (
        <div className="bo-property-head">
          {data?.auction_format === "inperson"
            ? "In-Person Auction"
            : "Online Auction"}
        </div>
      )}

      <div className="bids-box">
        <div className="bids-content">
          {!mobileWidth && (
            <div>
              <div className="currBid mt-1">
                {data.bidcount
                  ? "Current Bid"
                  : data?.enable_start_price === "true"
                    ? "Opening Bid"
                    : "Opening Bid"}
              </div>
              <div className="bc-head mt-1">
                {data.bidcount
                  ? `$${setDecimalPoint(data.wprice)}`
                  : data?.enable_start_price === "true" && data?.sprice
                    ? `$${setDecimalPoint(data.sprice)}`
                    : "TBD"}
              </div>
            </div>
          )}
          {mobileWidth ? (
            <>
              <div>
                <div className="currBid mt-1">
                  {data.bidcount
                    ? "Current Bid"
                    : data?.enable_start_price === "true" && data?.sprice
                      ? "Opening Bid"
                      : "Opening Bid"}
                </div>
                <div className="bc-head mt-1">
                  {data.bidcount
                    ? `$${setDecimalPoint(data.wprice)}`
                    : data?.enable_start_price === "true" && data?.sprice
                      ? `$${setDecimalPoint(data.sprice)}`
                      : "TBD"}
                </div>
              </div>
            </>
          ) : (
            ""
          )}

          {/* {from === "practice" && mobileWidth ? (
            ""
          ) : (
            <div>
              <div className="bc-head">{data.bidcount}</div>
              <div className="bc-text">Bids</div>
            </div>
          )} */}

          {/* {mobileWidth && from !== "practice" ? (
            <div>
              <div className="bc-head">{data.views || 0}</div>
              <div className="bc-text">Views</div>
            </div>
          ) : (
            ""
          )} */}
          {/* <div>
            <div className="bc-head no-wrap">
              {moment(data.date_closed).format("MM/DD/YY") +
                " at " +
                moment(data.date_closed).format("LT")}
            </div>
            <div className="bc-text">Ending on</div>
          </div> */}
        </div>

        <div className="bids-content">
          {data?.auction_format === "inperson" &&
          data?.auction_inperson_location ? (
            <>
              <div>
                <div className="currBid mt-1">Location</div>
                <div className="listingbidlocation">
                  {data?.auction_inperson_location}
                </div>
              </div>
            </>
          ) : null}
        </div>

        <div className="bidSts">
          {(data.market_status === "open" || "sold") &&
          data.wprice != 0 &&
          data.rprice != 0 &&
          data.admin_approved == 1 &&
          data.show_min_price_indicator === "true" &&
          data.bidcount > 0 ? (
            <>
              {data.wprice >= data.rprice
                ? `Minimum Sale Price Achieved`
                : `Minimum Sale Price Not Met`}
            </>
          ) : null}
        </div>

        {/* {from === "practice" ? (
          ""
        ) : (
          <p className="property-head text-center my-2">
            <Tooltip
              title="The home will be accepting bids in real-time, online on the Live Bidding date. Before you can submit a bid, you must register to bid. The timer resets to 3 minutes for each bid received after the auction end time. When bidding closes and the seller's minimum has been reached, the highest bidder will be contacted by the seller to complete the transaction."
              classes={{ tooltip: classes.customFontSize }}
              arrow
              placement="top"
            >
              <span className="how-comments-work">How Bidding Works</span>
            </Tooltip>
          </p>
        )} */}
      </div>
      {timer &&
      Object.keys(timer)?.length != 0 &&
      data.auction == 1 &&
      data?.auction_format !== "inperson" &&
      data.market_status != "sold" &&
      timer?.isCompleted != true &&
      !isAuctionTimerCompleted ? (
        <div>
          <span className="headTil">
            <PrimaryButton
              onClick={() => submittingBid()}
              btnSize="small"
              disabled={
                data?.listing_status !== "open" ||
                data?.market_status !== "open"
              }
              label={
                <>
                  {userLoggedIn.get ? (
                    userDetails.get["id"] == data.user_id ? (
                      "Can't bid on own property"
                    ) : data?.listing_status === "coming_soon" ? (
                      "Coming Soon"
                    ) : timer.isCompleted === false &&
                      timer.text === "Auction Ends In" &&
                      rtbCompleted &&
                      timer.text !== "Bidding Starts In" &&
                      highestBidder &&
                      !!Object.keys(userDetails.get).length &&
                      userDetails.get["id"] == highestBidder ? (
                      data.wprice >= data.rprice ? (
                        "You are the Highest Bidder"
                      ) : (
                        "Submit a Bid"
                      )
                    ) : timer.isCompleted === false &&
                      timer.text === "Auction Ends In" &&
                      rtbCompleted &&
                      timer.text !== "Bidding Starts In" ? (
                      "Submit a Bid"
                    ) : timer.isCompleted === false &&
                      (timer.text === "Auction Ends In" ||
                        timer.text === "Bidding Starts In") &&
                      !rtbCompleted ? (
                      <>Auction Registration</>
                    ) : timer.isCompleted === false &&
                      timer.text === "Bidding Starts In" &&
                      rtbCompleted ? (
                      "Accepting Bids Soon"
                    ) : (
                      "Bidding Closed"
                    )
                  ) : data?.listing_status === "coming_soon" ? (
                    "Coming Soon"
                  ) : timer.isCompleted === false ? (
                    <>Auction Registration</>
                  ) : (
                    "Bidding Closed"
                  )}
                </>
              }
            />
          </span>
        </div>
      ) : null}
      {/* <button className="btn btn-primary w-100" onClick={submittingBid}>
        {userLoggedIn.get
          ? userDetails.get["id"] == data.user_id
            ? "Can't bid on own property"
            : timer.isCompleted === false &&
              timer.text === "Auction Ends In" &&
              highestBidder &&
              !!Object.keys(userDetails.get).length &&
              userDetails.get["id"] == highestBidder
            ? "You are High Bidder"
            : timer.isCompleted === false &&
              timer.text === "Auction Ends In" &&
              timer.text === "Bidding Starts In" &&
              !rtbCompleted
            ? "Register for Auction"
            : timer.isCompleted === true
            ? "Bidding has closed"
            : "ACCEPTING BIDS SOON"
          : "Register for Auction"}
      </button> */}
      <div className="bids-box timerBidBox">
        <div className="bids-content">
          {!mobileWidth && (
            <>
              <div>
                <div className="pl-text">
                  {Object.keys(timer).length !== 0 &&
                  timer.isCompleted === false &&
                  timer.text === "Bidding Starts In"
                    ? "Auction Starts"
                    : data?.auction_format === "inperson"
                      ? "Auction Started"
                      : ""}
                </div>
                <div className="pvd-tc no-wrap mt-1">
                  <Timer
                    item={data}
                    isAuctionTimerCompleted={handleAuctionTimerCompleted}
                  />
                  {/* {Object.keys(timer).length !== 0 && (
                    <>
                      {timer.isCompleted === true ? (
                        <span className="pv-timer" style={{ color: "#000" }}>
                          Closed
                        </span>
                      ) : timer.text === "Bidding Starts In" ? (
                        <span className="bc-head" style={{ color: "#000" }}>
                          {moment(data.date_added).format("MM/DD/YY") +
                            " at " +
                            moment(data.date_added).format("LT")}
                        </span>
                      ) : (
                        <span className="pv-timer">{`${timer.days}D ${timer.hours}H ${timer.minutes}:${timer.seconds}`}</span>
                      )}
                    </>
                  )} */}
                </div>
              </div>
            </>
          )}
          {mobileWidth && (
            <>
              <div>
                <div className="pl-text">
                  {Object.keys(timer).length !== 0 &&
                  timer.isCompleted === false &&
                  timer.text === "Bidding Starts In"
                    ? "Auction Starts"
                    : data?.auction_format === "inperson"
                      ? "Auction Started"
                      : ""}
                </div>
                <div className="pvd-tc no-wrap mt-1">
                  <Timer
                    item={data}
                    isAuctionTimerCompleted={handleAuctionTimerCompleted}
                  />
                  {/* {Object.keys(timer).length !== 0 && (
                    <>
                      {timer.isCompleted === true ? (
                        <span className="pv-timer" style={{ color: "#000" }}>
                          Closed
                        </span>
                      ) : timer.text === "Bidding Starts In" ? (
                        <span className="bc-head" style={{ color: "#000" }}>
                          {moment(data.date_added).format("MM/DD/YY") +
                            " at " +
                            moment(data.date_added).format("LT")}
                        </span>
                      ) : (
                        <span className="pv-timer">{`${timer.days}D ${timer.hours}H ${timer.minutes}:${timer.seconds}`}</span>
                      )}
                    </>
                  )} */}
                </div>
              </div>
            </>
          )}
          {mobileWidth && from === "practice" ? (
            <>
              <div>
                <div className="pvd-tc">
                  {Object.keys(timer).length !== 0 && (
                    <>
                      {timer.isCompleted === true ? (
                        <span className="pv-timer" style={{ color: "#000" }}>
                          Closed
                        </span>
                      ) : timer.text === "Bidding Starts In" ? (
                        <span className="pv-timer" style={{ color: "#000" }}>
                          {moment(data.date_added).format("MM/DD/YY") +
                            " at " +
                            moment(data.date_added).format("LT")}
                        </span>
                      ) : (
                        <span className="pv-timer">{`${timer.days}D ${timer.hours}H ${timer.minutes}:${timer.seconds}`}</span>
                      )}
                    </>
                  )}
                </div>
                <div className="pl-text">
                  {Object.keys(timer).length !== 0 &&
                    timer.isCompleted === false &&
                    timer.text}
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      <RuumrModal
        open={modalopen}
        handleClose={toggleModal}
        modalClass="biddingModal"
      >
        <BiddingForm
          data={data}
          timer={timer}
          limit="unlimited"
          customerid={
            userDetails.get.customerid ? userDetails.get.customerid : ""
          }
          nextBidAmount={nextBidAmount}
          setNextBidAmount={setNextBidAmount}
          seyProductDetails={seyProductDetails}
          handleClose={toggleModal}
          width={width}
          isMobile={isMobile}
          highestBidder={highestBidder}
          myClientsList={myClientsList}
          myAgent={myAgent}
          from={from}
          setSubmittedPracticeOffer={setSubmittedPracticeOffer}
          submittedPracticeOffer={submittedPracticeOffer}
        />
      </RuumrModal>
    </div>
  );
};

export default PropertyBids;
